var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{class:_vm.badgeType.class,attrs:{"no-body":""}},[_c('div',{class:['ribbon', _vm.badgeType.colorClass],domProps:{"innerHTML":_vm._s(_vm.sign)}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-382676ba","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-base/components-custom/badges/badges.vue
// module id = null
// module chunks = 